import { useEffect } from 'react';
import styles from './Toast.module.css';

export default function Toast({ msg, message, onDone, onClose }) {
  const displayMessage = message || msg;
  const handleClose = onClose || onDone;

  useEffect(() => {
    if (handleClose) {
      const t = setTimeout(handleClose, 2800);
      return () => clearTimeout(t);
    }
  }, [handleClose]);

  if (!displayMessage) return null;

  return (
    <div className={styles.toast}>
      ✅ {displayMessage}
    </div>
  );
}

